import React from 'react';
import classname from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons';

import { BaseNotification, BaseNotificationProps } from './BaseNotification';

export enum NotificationType {
    INFO = 'info',
    ERROR = 'error',
    SUCCESS = 'success',
}

interface NotificationProps extends Omit<BaseNotificationProps, 'className'> {
    title: string;
    subtitle?: string;
    type: NotificationType;
}

const classes = {
    [NotificationType.INFO]: { containerClasses: 'border-brand', titleClasses: 'text-brand' },
    [NotificationType.ERROR]: { containerClasses: 'border-error', titleClasses: 'text-error' },
    [NotificationType.SUCCESS]: {
        containerClasses: 'border-success',
        titleClasses: 'text-success',
    },
};

export const Notification = (props: NotificationProps) => {
    return (
        <BaseNotification
            {...props}
            title={
                <Title
                    title={props.title}
                    subtitle={props.subtitle}
                    className={classes[props.type].titleClasses}
                />
            }
            className={classes[props.type].containerClasses}
        />
    );
};

const Title = ({
    title,
    subtitle,
    className,
}: {
    title: string;
    subtitle?: string;
    className: string;
}) => {
    return (
        <div className={classname(className, 'flex')}>
            <FontAwesomeIcon icon={faExclamationCircle} size="lg" className="mr-2" />
            <div>
                <p className="text-lg font-semibold">{title}</p>
                <p className="text-grey-2 font-semibold text-xs">{subtitle}</p>
            </div>
        </div>
    );
};
